/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type GetProgramsQueryVariables = Types.Exact<{
  orgId: Types.Scalars['uuid']['input'];
}>;

export type GetProgramsQuery = {
  __typename?: 'query_root';
  programs: Array<{
    __typename?: 'programs';
    id: string;
    name: string;
    description?: string | null;
    order?: string | null;
    hidden: boolean;
    created_at?: string | null;
    created_by?: string | null;
    framework?: { __typename: 'frameworks'; name: string } | null;
    template_framework?: { __typename: 'template_frameworks'; name: string } | null;
    program_assignees: Array<{
      __typename?: 'program_assignees';
      user: { __typename?: 'users'; id: string; displayName: string };
    }>;
  }>;
};

export const GetProgramsDocument = `
    query GetPrograms($orgId: uuid!) {
  programs(
    where: {organization_id: {_eq: $orgId}}
    order_by: [{order: asc_nulls_last}, {created_at: asc}]
  ) {
    id
    name
    description
    order
    hidden
    created_at
    created_by
    framework {
      name
      __typename
    }
    template_framework {
      name
      __typename
    }
    program_assignees {
      user {
        id
        displayName
      }
    }
  }
}
    ` as string & TypedDocumentNode<GetProgramsQuery, GetProgramsQueryVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    GetPrograms: build.query<GetProgramsQuery, GetProgramsQueryVariables>({
      query: (variables) => ({ document: GetProgramsDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGetProgramsQuery, useLazyGetProgramsQuery } = injectedRtkApi;
